var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { FormattedMessage, FormattedRelative, FormattedDate } from 'react-intl';

import { isToday, isYesterday, isCurrentYear } from '../../utils/datetime';

import messages from './messages';

var ReadableTime = function ReadableTime(_ref) {
    var timestamp = _ref.timestamp,
        relativeThreshold = _ref.relativeThreshold,
        _ref$allowFutureTimes = _ref.allowFutureTimestamps,
        allowFutureTimestamps = _ref$allowFutureTimes === undefined ? true : _ref$allowFutureTimes,
        _ref$alwaysShowTime = _ref.alwaysShowTime,
        alwaysShowTime = _ref$alwaysShowTime === undefined ? false : _ref$alwaysShowTime;

    var relativeIfNewerThanTs = Date.now() - relativeThreshold;
    var shouldShowYear = !isCurrentYear(timestamp);

    if (!allowFutureTimestamps && timestamp > Date.now()) {
        timestamp = relativeIfNewerThanTs; // Default to 'Today' for timestamps that would show a future date
    }

    // e.g. Oct 5, 2018
    var dateMessage = messages.eventTime;
    var date = null;
    if (isToday(timestamp)) {
        // e.g. Today at 12:30 PM
        dateMessage = messages.eventTimeToday;
    } else if (isYesterday(timestamp)) {
        // e.g. Yesterday at 11:30 AM
        dateMessage = messages.eventTimeYesterday;
    } else if (shouldShowYear && alwaysShowTime) {
        // e.g. Oct 5, 2018 at 10:30 PM
        dateMessage = messages.eventTimeDate;
    } else if (!shouldShowYear && alwaysShowTime) {
        // e.g. Oct 5 at 10:30 PM
        dateMessage = messages.eventTimeDateShort;
        date = React.createElement(FormattedDate, { value: timestamp, month: 'short', day: 'numeric' });
    } else if (!shouldShowYear && !alwaysShowTime) {
        // e.g. Oct 5
        return React.createElement(FormattedDate, { value: timestamp, month: 'short', day: 'numeric' });
    }

    return timestamp > relativeIfNewerThanTs ? React.createElement(FormattedRelative, { value: timestamp }) : React.createElement(FormattedMessage, _extends({}, dateMessage, {
        values: { time: timestamp, date: date }
    }));
};

ReadableTime.propTypes = {
    /** The timestamp which should be used to display the date */
    timestamp: PropTypes.number.isRequired,

    /** The number of milliseconds before now that a relative (vs. absolute) time should be displayed */
    relativeThreshold: PropTypes.number.isRequired,

    /** A boolean that will cause future timestamps (usually due to incorrect computer time) to be corrected to the isToday message */
    allowFutureTimestamps: PropTypes.bool,

    /** A boolean that will include the time alongside the date, if the date is shown */
    alwaysShowTime: PropTypes.bool
};
export default ReadableTime;
import PropTypes from 'prop-types';